<div class="body">
    <div class="flex">
        <header>Dados Aluno</header>
        <div class="flex-fill"></div>
        <div>
            <button mat-button color="primary" (click)="voltar()">Voltar</button>
        </div>
    </div>

    <mat-card class="mat-elevation-z8" *ngIf="!error;else errorTemplate">
        <mat-card-title></mat-card-title>
        <mat-card-content>
            <div class="loading-shade" *ngIf="isLoadingResults">
                <mat-spinner></mat-spinner>
            </div>
            <div class="content" *ngIf="!isLoadingResults">
                <form [formGroup]="form">
                    <title-line title="Dados Gerais"></title-line>
                    <div class="grid grid--auto-fill">
                        <mat-form-field>
                            <mat-label>CPF</mat-label>
                            <input formControlName="cpf" [mask]="cpfMask" matInput>
                            <mat-error *ngIf="form.get('cpf').hasError('cpfInvalido')">CPF inválido</mat-error>
                            <mat-error *ngIf="form.get('cpf').hasError('required')">Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field *ngIf="unidadesDefault; else loading">
                            <mat-label>Unidade</mat-label>
                            <input matInput [matAutocomplete]="auto" formControlName="unidadeSelect">
                            <mat-icon matSuffix>arrow_drop_down</mat-icon>
                            <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let unidade of filterUnidades | async" [value]="unidade.nome">
                                    <span>{{unidade.nome}}</span>
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Nome</mat-label>
                            <input appTitlecase formControlName="nome" matInput >
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Data de nascimento</mat-label>
                            <input formControlName="dataNascimento" matInput [max]="today" [matDatepicker]="picker">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker startView="multi-year"></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Sexo</mat-label>
                            <mat-select formControlName="sexo">
                                <mat-option [value]="1"> Masculino  </mat-option>
                                <mat-option [value]="2"> Feminino  </mat-option>
                                <mat-option [value]="3"> Outros  </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>RG</mat-label>
                            <input formControlName="rg" matInput>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Orgão Expedidor</mat-label>
                            <input formControlName="orgaoExpedicao" matInput appUppercase>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Estado civil</mat-label>
                            <mat-select formControlName="estadoCivil">
                                <mat-option [value]="1"> Solterio(a)  </mat-option>
                                <mat-option [value]="2"> Casado(a)  </mat-option>
                                <mat-option [value]="3"> Viúvo(a)  </mat-option>
                                <mat-option [value]="4"> Divorciado(a)  </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="grid grid--auto-fill">
                        <mat-form-field *ngIf="nacionalidadeDefault; else loading">
                            <mat-label>Nacionalidade</mat-label>
                            <input matInput [matAutocomplete]="auto" formControlName="nacionalidade">
                            <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let nacionalidade of filterNacionalidade | async" [value]="nacionalidade.descricao">
                                    <div class="flex flex-row">
                                        <span>{{nacionalidade.descricao}}</span>
                                    </div>
                                </mat-option>
                            </mat-autocomplete>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field *ngIf="naturalidadeDefault; else loading">
                            <mat-label>Naturalidade</mat-label>
                            <input matInput [matAutocomplete]="auto" formControlName="naturalidade">
                            <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let naturalidade of filterNaturalidade | async" [value]="naturalidade.descricao">
                                    <div class="flex flex-row">
                                        <span>{{naturalidade.descricao}}</span>
                                    </div>
                                </mat-option>
                            </mat-autocomplete>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="grid grid--auto-fill">
                        <mat-form-field>
                            <mat-label>Título Eleitoral</mat-label>
                            <input formControlName="tituloEleitoral" matInput>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Zona</mat-label>
                            <input formControlName="zona" matInput>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Seção</mat-label>
                            <input formControlName="secao" matInput>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="grid grid--auto-fill">
                        <mat-form-field>
                            <mat-label>Nome do Responsável</mat-label>
                            <input formControlName="nomeResponsavel" matInput appTitlecase>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>RG do Responsável</mat-label>
                            <input formControlName="rgResponsavel" matInput>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>CPF do Responsável</mat-label>
                            <input formControlName="cpfResponsavel" [mask]="cpfMask" matInput>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Nome da Mãe</mat-label>
                            <input formControlName="nomeMae" matInput appTitlecase>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>
                    </div>

                    <title-line title="Endereço"></title-line>
                    <div formGroupName="endereco" class="grid grid--auto-fill">
                        <mat-form-field>
                            <mat-label>CEP</mat-label>
                            <input formControlName="cep" [mask]="maskCep" matInput>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Rua</mat-label>
                            <input formControlName="rua" matInput appTitlecase>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Número</mat-label>
                            <input formControlName="numero" matInput>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Complemento</mat-label>
                            <input formControlName="complemento" matInput appTitlecase>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Bairro</mat-label>
                            <input formControlName="bairro" matInput appTitlecase>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Cidade</mat-label>
                            <input formControlName="cidade" matInput appTitlecase>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Estado</mat-label>
                            <mat-select formControlName="estado">
                                <mat-option *ngFor="let estado of estados" [value]="estado">
                                    {{ estado }}
                                </mat-option>
                            </mat-select>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>
                    </div>

                    <title-line title="Contato"></title-line>
                    <div formGroupName="contato" class="grid grid--auto-fill">
                        <mat-form-field>
                            <mat-label>Celular / WhatsApp</mat-label>
                            <input formControlName="celular" id="idCelular" [mask]="maskCelular" matInput>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Telefone</mat-label>
                            <input formControlName="telefoneFixo" [mask]="maskTelefoneFixoPrincipal" matInput>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>E-mail</mat-label>
                            <input formControlName="email" id="idEmail" matInput appLowwercase ngModel email autocomplete="on">
                            <mat-error>E-mail Incorreto, por favor corrigir.</mat-error>
                        </mat-form-field>

                        <mat-form-field style="display: none!important;">
                            <mat-label>Facebook</mat-label>
                            <input formControlName="faceBook" matInput appLowwercase>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field style="display: none!important;">
                            <mat-label>Instagram</mat-label>
                            <input formControlName="instagram" matInput appLowwercase>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Como nos conheceu?</mat-label>
                            <mat-select formControlName="comoConheceuEnum">
                                <mat-option [value]="1">Indicação</mat-option>
                                <mat-option [value]="2">Google</mat-option>
                                <mat-option [value]="3">Facebook</mat-option>
                                <mat-option [value]="4">Instagram</mat-option>
                                <mat-option [value]="5">Passou em frente</mat-option>
                                <mat-option [value]="6">Whatsapp</mat-option>
                                <mat-option [value]="7">Faixas na rua</mat-option>
                                <mat-option [value]="8">Panfleto</mat-option>
                                <mat-option [value]="9">Ônibus</mat-option>
                                <mat-option [value]="10">Cartaz em comércio</mat-option>
                                <mat-option [value]="11">Jornal</mat-option>
                                <mat-option [value]="12">Televisão</mat-option>
                                <mat-option [value]="13">Rádio</mat-option>
                                <mat-option [value]="14">Chat on-line</mat-option>
                                <mat-option [value]="15">Lista telefônica</mat-option>
                                <mat-option [value]="16">Tele-responde</mat-option>
                                <mat-option [value]="17">Pesquisa</mat-option>
                                <mat-option [value]="18">Outdoor</mat-option>
                                <mat-option [value]="19">Muro</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <div class="flex align-center prl-1-5">
                            <mat-slide-toggle formControlName="receberEmail" color="primary" [disabled]="!permissaoEditarFormasContato">Envio de E-mail</mat-slide-toggle>
                        </div>

                        <div class="flex align-center prl-1-5">
                            <mat-slide-toggle formControlName="receberWhatsApp" color="primary" [disabled]="!permissaoEditarFormasContato">WhatsApp</mat-slide-toggle>
                        </div>

                        <div class="flex align-center prl-1-5" >
                            <mat-slide-toggle formControlName="recebeSMS" color="primary" [disabled]="!permissaoEditarFormasContato">SMS</mat-slide-toggle>
                        </div>

                        <div class="flex align-center prl-1-5" style="display: none!important;">
                            <mat-slide-toggle formControlName="receberFacebook" color="primary">Facebook</mat-slide-toggle>
                        </div>

                        <div class="flex align-center prl-1-5" style="display: none!important;">
                            <mat-slide-toggle formControlName="receberInstagram" color="primary">Instagram</mat-slide-toggle>
                        </div>

                    </div>

                    <div class="flex">
                        <div>
                            <button mat-button color="primary" (click)="voltar()" type="button">Voltar</button>
                        </div>
                        <div class="flex-fill"></div>
                        <div>
                            <button style="visibility: hidden;" id="btnSalvarData" mat-raised-button color="primary" type="button" (click)="salvarData()">TESTE &nbsp;<mat-icon>send</mat-icon></button>
                            <button *ngIf="id !== 0" mat-raised-button color="primary" type="button" (click)="onBlurMethod()" cdkFocusInitial>Salvar</button>
                            <button *ngIf="id === 0" mat-raised-button color="primary" type="button" (click)="onBlurMethod()" cdkFocusInitial>Continuar &nbsp;<mat-icon>send</mat-icon></button>
                        </div>
                    </div>
                </form>
            </div>
        </mat-card-content>
        <mat-card-actions>
        </mat-card-actions>
    </mat-card>
</div>

<!-- <input #imgProfile class="file-upload" type="file" accept='image/*' (change)="loadImgProfile($event)"> -->

<ng-template #errorTemplate>
    <app-server-error></app-server-error>
</ng-template>

<ng-template #loading>
    <mat-spinner [diameter]="25"></mat-spinner>
</ng-template>
